interface IntegrationCard {
  title: string;
  description: string;
  icon: string;
}

export function IntegrationProcessSection() {
  const integrationCards: IntegrationCard[] = [
    {
      title: 'Ödeme Sistemleri',
      description:
        'Tüm popüler ödeme yöntemlerini destekleyen güvenli altyapı ile müşterilerinize esnek ödeme seçenekleri sunun.',
      icon: '💳',
    },
    {
      title: 'Kargo Entegrasyonları',
      description:
        'Önde gelen kargo firmaları ile entegrasyon sayesinde teslimat süreçlerinizi optimize edin ve müşteri deneyimini artırın.',
      icon: '🚚',
    },
    {
      title: 'ERP Sistemleri',
      description:
        'Mevcut ERP sisteminizle sorunsuz entegrasyon kurarak stok, finansal ve operasyonel verileri merkezi bir noktada yönetin.',
      icon: '⚙️',
    },
    {
      title: 'CRM & Analytics',
      description:
        'Müşteri ilişkileri yönetimi ve analitik araçları ile satış performansınızı artırın ve veri odaklı kararlar alın.',
      icon: '📊',
    },
  ];

  return (
    <>
      <style
        dangerouslySetInnerHTML={{
          __html: `
          @media (max-width: 768px) {
            .mobile-integration-section {
              padding: 40px 20px !important;
              gap: 32px !important;
            }
            .mobile-integration-title {
              font-size: 32px !important;
              line-height: 40px !important;
              letter-spacing: -0.64px !important;
            }
            .mobile-integration-description {
              font-size: 14px !important;
              line-height: 22px !important;
              max-width: 100% !important;
              width: 100% !important;
            }
            .mobile-integration-grid {
              grid-template-columns: 1fr !important;
              grid-template-rows: repeat(4, auto) !important;
              height: auto !important;
              gap: 16px !important;
              justify-content: stretch !important;
            }
            .mobile-integration-card {
              grid-column: 1 !important;
              grid-row: auto !important;
              height: auto !important;
              min-height: 300px !important;
              padding: 20px !important;
              gap: 16px !important;
            }
            .mobile-integration-card-title {
              font-size: 18px !important;
              line-height: 24px !important;
            }
            .mobile-integration-card-description {
              font-size: 14px !important;
              line-height: 20px !important;
              width: 100% !important;
              max-width: 100% !important;
            }
            .mobile-integration-card-description[class*="w-["] {
              width: 100% !important;
            }
            .mobile-integration-section {
              overflow-x: hidden !important;
              max-width: 100vw !important;
            }
            .mobile-integration-visual {
              padding: 16px !important;
            }
            .mobile-integration-eyebrow {
              position: static !important;
              align-self: flex-start !important;
              top: auto !important;
              left: auto !important;
              margin-bottom: 16px !important;
            }
            .mobile-integration-title {
              margin-top: 20px !important;
            }
          }
        `,
        }}
      />
      <section
        className="mobile-integration-section"
        style={{
          position: 'relative',
          display: 'flex',
          padding: '60px',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: '48px',
          alignSelf: 'stretch',
          background: 'var(--Background, #020816)',
        }}
      >
        {/* Eyebrow Badge */}
        <div
          className="absolute top-8 left-8 mobile-integration-eyebrow"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            zIndex: 10,
          }}
        >
          <div
            style={{
              width: '40px',
              height: '1px',
              background: '#76BCE8',
            }}
          />
          <span
            style={{
              color: '#9DD0F0',
              fontFamily: 'Inter',
              fontSize: '11px',
              fontStyle: 'normal',
              fontWeight: 600,
              lineHeight: 'normal',
              letterSpacing: '3px',
              textTransform: 'uppercase',
            }}
          >
            ENTEGRASYON SÜRECİMİZ
          </span>
        </div>

        {/* Title */}
        <h2
          className="mobile-integration-title"
          style={{
            color: '#FFF',
            textAlign: 'center',
            fontFamily: 'Inter',
            fontSize: '48px',
            fontStyle: 'normal',
            fontWeight: 700,
            lineHeight: '55.2px',
            letterSpacing: '-0.96px',
            alignSelf: 'center',
            marginTop: '80px',
          }}
        >
          Tüm Sistemlerinizi Sorunsuz
          <br />
          Şekilde Birleştiriyoruz
        </h2>

        {/* Description */}
        <p
          className="mobile-integration-description"
          style={{
            color: 'rgba(255, 255, 255, 0.40)',
            textAlign: 'center',
            fontFamily: 'Inter',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '25.6px',
            alignSelf: 'center',
            maxWidth: '600px',
          }}
        >
          Ödeme, kargo, ERP ve diğer iş sistemlerinizi tek bir altyapıda entegre
          ederek kesintisiz ve ölçeklenebilir bir operasyon sunuyoruz.
        </p>

        {/* Cards Grid */}
        <div
          className="mobile-integration-grid"
          style={{
            display: 'grid',
            height: '938.56px',
            rowGap: '20px',
            columnGap: '20px',
            alignSelf: 'stretch',
            gridTemplateRows: '458.78px 459.78px',
            gridTemplateColumns: 'repeat(2, 520px)',
            justifyContent: 'center',
          }}
        >
          {integrationCards.map((_, index) => (
            <div
              key={index}
              className="mobile-integration-card"
              style={{
                display: 'flex',
                padding: '32px',
                flexDirection: 'column',
                alignItems: 'flex-start',
                gap: '9.2px',
                gridRow: index < 2 ? '1 / span 1' : '2 / span 1',
                gridColumn: (index % 2) + 1 + ' / span 1',
                justifySelf: 'stretch',
                borderRadius: '14px',
                border: '1px solid rgba(255, 255, 255, 0.08)',
                background: '#0E1423',
              }}
            >
              {index === 0 ? (
                // İlk karta özel içerik
                <>
                  {/* Step Badge */}
                  <div className="size- px-3 py-1 rounded-md outline outline-1 outline-offset-[-1px] outline-white/10 inline-flex justify-start items-start">
                    <div className="justify-center text-white/60 text-xs font-medium font-['Inter']">
                      Step 1
                    </div>
                  </div>

                  {/* Title */}
                  <div className="self-stretch justify-center text-white text-xl font-bold font-['Inter'] mobile-integration-card-title">
                    İhtiyaç Analizi
                  </div>

                  {/* Description */}
                  <div className="w-[459px] justify-center text-white/40 text-sm font-normal font-['Inter'] leading-6 mobile-integration-card-description">
                    Mevcut altyapınızı analiz ederek ihtiyaç duyduğunuz
                    entegrasyonları ve veri akışlarını belirliyoruz.
                  </div>

                  {/* Radar/Analysis Visual */}
                  <div className="self-stretch px-6 pt-10 pb-6 bg-stone-950 rounded-xl outline outline-1 outline-offset-[-1px] outline-white/5 inline-flex flex-col justify-start items-start mobile-integration-visual">
                    <div className="self-stretch inline-flex justify-start items-center gap-5">
                      <div className="size- inline-flex flex-col justify-start items-center gap-3">
                        <div className="size-32 flex flex-col justify-center items-center">
                          <div className="size-32 relative rounded-[65px] overflow-hidden">
                            <div className="size-32 left-0 top-0 absolute rounded-[65px] border border-slate-600" />
                            <div className="size-20 left-6 top-6 absolute rounded-[40px] border border-blue-600" />
                            <div className="size-11 left-[42px] top-[42px] absolute rounded-[22px] outline outline-1 outline-sky-900" />
                          </div>
                        </div>
                        <div className="size- flex flex-col justify-start items-start">
                          <div className="justify-center text-white/30 text-[10px] font-medium font-['Inter']">
                            Analyzing current workflow..
                          </div>
                        </div>
                      </div>
                      <div className="flex-1 inline-flex flex-col justify-start items-start gap-[3px]">
                        <div className="self-stretch px-3.5 py-2.5 rounded-md outline outline-1 outline-offset-[-1px] outline-white/5 inline-flex justify-start items-center gap-2.5">
                          <div className="size-3.5 relative overflow-hidden">
                            <div className="size-2.5 left-[1.75px] top-[1.72px] absolute outline outline-1 outline-offset-[-0.44px] outline-white/40" />
                          </div>
                          <div className="size- inline-flex flex-col justify-start items-start">
                            <div className="justify-center text-white/60 text-xs font-medium font-['Inter']">
                              Ödeme Sistemleri
                            </div>
                          </div>
                        </div>
                        <div className="self-stretch px-3.5 py-2.5 rounded-md outline outline-1 outline-offset-[-1px] outline-white/5 inline-flex justify-start items-center gap-2.5">
                          <div className="size-3.5 relative overflow-hidden">
                            <div className="size-2.5 left-[1.75px] top-[1.75px] absolute outline outline-1 outline-offset-[-0.44px] outline-white/40" />
                          </div>
                          <div className="size- inline-flex flex-col justify-start items-start">
                            <div className="justify-center text-white/60 text-xs font-medium font-['Inter']">
                              Kargo Altyapısı
                            </div>
                          </div>
                        </div>
                        <div className="self-stretch px-3.5 py-2.5 rounded-md outline outline-1 outline-offset-[-1px] outline-white/5 inline-flex justify-start items-center gap-2.5">
                          <div className="size-3.5 relative overflow-hidden">
                            <div className="size-2.5 left-[1.75px] top-[1.75px] absolute outline outline-1 outline-offset-[-0.44px] outline-white/40" />
                          </div>
                          <div className="size- inline-flex flex-col justify-start items-start">
                            <div className="justify-center text-white/60 text-xs font-medium font-['Inter']">
                              ERP/Muhasebe
                            </div>
                          </div>
                        </div>
                        <div className="self-stretch px-3.5 py-2.5 rounded-md outline outline-1 outline-offset-[-1px] outline-white/5 inline-flex justify-start items-center gap-2.5">
                          <div className="size-3.5 relative overflow-hidden">
                            <div className="size-2.5 left-[1.75px] top-[1.75px] absolute outline outline-1 outline-offset-[-0.44px] outline-white/40" />
                          </div>
                          <div className="size- inline-flex flex-col justify-start items-start">
                            <div className="justify-center text-white/60 text-xs font-medium font-['Inter']">
                              Bildirim servisleri
                            </div>
                          </div>
                        </div>
                        <div className="self-stretch px-3.5 py-2.5 rounded-md outline outline-1 outline-offset-[-1px] outline-white/5 inline-flex justify-start items-center gap-2.5">
                          <div className="size-3.5 relative overflow-hidden">
                            <div className="size-2.5 left-[1.75px] top-[1.75px] absolute outline outline-1 outline-offset-[-0.44px] outline-white/40" />
                          </div>
                          <div className="size- inline-flex flex-col justify-start items-start">
                            <div className="justify-center text-white/60 text-xs font-medium font-['Inter']">
                              Veri akışları
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : index === 1 ? (
                // İkinci karta özel içerik
                <>
                  {/* Step Badge */}
                  <div className="size- px-3 py-1 rounded-md outline outline-1 outline-offset-[-1px] outline-white/10 inline-flex justify-start items-start">
                    <div className="justify-center text-white/60 text-xs font-medium font-['Inter']">
                      Step 2
                    </div>
                  </div>

                  {/* Title */}
                  <div className="self-stretch justify-center text-white text-xl font-bold font-['Inter'] mobile-integration-card-title">
                    Entegrasyon Geliştirme
                  </div>

                  {/* Description */}
                  <div className="w-[462px] justify-center text-white/40 text-sm font-normal font-['Inter'] leading-6 mobile-integration-card-description">
                    İhtiyaçlarınıza özel entegrasyonlar geliştirerek tüm
                    sistemlerinizi güvenli ve uyumlu şekilde birbirine
                    bağlıyoruz.
                  </div>

                  {/* Code Editor Visual */}
                  <div className="self-stretch px-6 pt-10 pb-6 bg-stone-950 rounded-xl outline outline-1 outline-offset-[-1px] outline-white/5 inline-flex flex-col justify-start items-start mobile-integration-visual">
                    <div className="self-stretch bg-neutral-950 rounded-[10px] outline outline-1 outline-offset-[-1px] outline-white/10 flex flex-col justify-start items-start overflow-hidden">
                      <div className="self-stretch h-8 px-3 border-b border-white/5 inline-flex justify-between items-center">
                        <div className="size- flex justify-start items-start gap-2">
                          <div className="self-stretch inline-flex flex-col justify-start items-start">
                            <div className="justify-center text-white/30 text-xs font-normal font-['Inter']">
                              ←
                            </div>
                          </div>
                          <div className="self-stretch inline-flex flex-col justify-start items-start">
                            <div className="justify-center text-white/30 text-xs font-normal font-['Inter']">
                              →
                            </div>
                          </div>
                        </div>
                        <div className="w-24 h-1.5 bg-white/10 rounded-[3px]" />
                        <div className="size- flex justify-start items-start gap-2">
                          <div className="self-stretch inline-flex flex-col justify-start items-start">
                            <div className="justify-center text-white/30 text-[10px] font-normal font-['Inter']">
                              □
                            </div>
                          </div>
                          <div className="self-stretch inline-flex flex-col justify-start items-start">
                            <div className="justify-center text-white/30 text-[10px] font-normal font-['Inter']">
                              −
                            </div>
                          </div>
                          <div className="self-stretch inline-flex flex-col justify-start items-start">
                            <div className="justify-center text-white/30 text-[10px] font-normal font-['Inter']">
                              ×
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="self-stretch inline-flex justify-start items-start">
                        <div className="w-9 self-stretch pt-3.5 border-r border-white/5 inline-flex flex-col justify-start items-center gap-3.5">
                          <div className="size-3.5 relative overflow-hidden">
                            <div className="w-2 h-2.5 left-[2.92px] top-[1.75px] absolute outline outline-1 outline-offset-[-0.44px] outline-white/30" />
                          </div>
                          <div className="size-3.5 relative overflow-hidden">
                            <div className="size-2.5 left-[1.75px] top-[1.75px] absolute outline outline-1 outline-offset-[-0.44px] outline-white/30" />
                          </div>
                          <div className="size-3.5 relative overflow-hidden">
                            <div className="size-2.5 left-[1.55px] top-[1.30px] absolute outline outline-1 outline-offset-[-0.44px] outline-white/30" />
                          </div>
                        </div>
                        <div className="flex-1 self-stretch px-4 pt-3.5 pb-4 inline-flex flex-col justify-start items-start">
                          <div className="self-stretch pb-[0.59px] flex flex-col justify-start items-start">
                            <div className="self-stretch justify-center">
                              <span className="text-sky-300 text-xs font-normal font-['JetBrains_Mono'] leading-5">
                                class
                              </span>
                              <span className="text-white/60 text-xs font-normal font-['JetBrains_Mono'] leading-5">
                                {' '}
                                AutomationTrigger:
                              </span>
                            </div>
                          </div>
                          <div className="self-stretch pl-5 pb-[0.59px] flex flex-col justify-start items-start">
                            <div className="self-stretch justify-center">
                              <span className="text-sky-300 text-xs font-normal font-['JetBrains_Mono'] leading-5">
                                payment.
                              </span>
                              <span className="text-white/60 text-xs font-normal font-['JetBrains_Mono'] leading-5">
                                connect
                              </span>
                              <span className="text-sky-300 text-xs font-normal font-['JetBrains_Mono'] leading-5">
                                (
                              </span>
                              <span className="text-emerald-300 text-xs font-normal font-['JetBrains_Mono'] leading-5">
                                Craftgate
                              </span>
                              <span className="text-sky-300 text-xs font-normal font-['JetBrains_Mono'] leading-5">
                                )
                              </span>
                              <br />
                              <span className="text-sky-300 text-xs font-normal font-['JetBrains_Mono'] leading-5">
                                {' '}
                                cargo.
                              </span>
                              <span className="text-white/60 text-xs font-normal font-['JetBrains_Mono'] leading-5">
                                connect
                              </span>
                              <span className="text-sky-300 text-xs font-normal font-['JetBrains_Mono'] leading-5">
                                (MNG)
                              </span>
                              <br />
                              <span className="text-sky-300 text-xs font-normal font-['JetBrains_Mono'] leading-5">
                                erp.
                              </span>
                              <span className="text-white/60 text-xs font-normal font-['JetBrains_Mono'] leading-5">
                                sync
                              </span>
                              <span className="text-sky-300 text-xs font-normal font-['JetBrains_Mono'] leading-5">
                                (MikroERP)
                              </span>
                              <br />
                              <span className="text-sky-300 text-xs font-normal font-['JetBrains_Mono'] leading-5">
                                notification.
                              </span>
                              <span className="text-white/60 text-xs font-normal font-['JetBrains_Mono'] leading-5">
                                enable
                              </span>
                              <span className="text-sky-300 text-xs font-normal font-['JetBrains_Mono'] leading-5">
                                (OneSignal)
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : index === 2 ? (
                // Üçüncü karta özel içerik
                <>
                  {/* Step Badge */}
                  <div className="size- px-3 py-1 rounded-md outline outline-1 outline-offset-[-1px] outline-white/10 inline-flex justify-start items-start">
                    <div className="justify-center text-white/60 text-xs font-medium font-['Inter']">
                      Step 3
                    </div>
                  </div>

                  {/* Title */}
                  <div className="self-stretch justify-center text-white text-xl font-bold font-['Inter'] mobile-integration-card-title">
                    Canlıya Alma &amp; Senkronizasyon
                  </div>

                  {/* Description */}
                  <div className="w-[468px] justify-center text-white/40 text-sm font-normal font-['Inter'] leading-6 mobile-integration-card-description">
                    Tüm entegrasyonlar sorunsuz şekilde devreye alınır ve
                    sistemleriniz arasında gerçek zamanlı veri akışı sağlanır.
                  </div>

                  {/* Integration Flow Visual */}
                  <div className="w-full p-6 bg-stone-950 rounded-xl outline outline-1 outline-offset-[-1px] outline-white/5 inline-flex flex-col justify-start items-start mobile-integration-visual">
                    <div className="self-stretch inline-flex justify-center items-center">
                      <div className="size- inline-flex flex-col justify-start items-center gap-3">
                        <div className="size-16 bg-stone-950 rounded-2xl outline outline-1 outline-offset-[-1px] outline-white/10 inline-flex justify-center items-center">
                          <img
                            className="w-16 h-10"
                            src="/Logo-cm.png"
                            alt="CommerceMinder Logo"
                          />
                        </div>
                        <div className="size- flex flex-col justify-start items-start">
                          <div className="justify-center text-white/40 text-xs font-medium font-['Inter']">
                            CommerceMinder
                          </div>
                        </div>
                      </div>
                      <div className="w-20 px-3 inline-flex flex-col justify-start items-start gap-1.5">
                        <div className="self-stretch h-0.5 relative bg-white/10 rounded-[99px]" />
                        <div className="self-stretch h-0.5 relative bg-white/10 rounded-[99px]" />
                        <div className="self-stretch h-0.5 relative bg-white/10 rounded-[99px]" />
                      </div>
                      <div className="size- inline-flex flex-col justify-start items-center gap-3">
                        <div className="size-16 bg-stone-950 rounded-2xl outline outline-1 outline-offset-[-1px] outline-white/10 inline-flex justify-center items-center">
                          <div className="size-8 relative overflow-hidden">
                            <div className="size-5 left-[5.33px] top-[5.33px] absolute outline outline-2 outline-offset-[-1px] outline-sky-300" />
                          </div>
                        </div>
                        <div className="size- flex flex-col justify-start items-start">
                          <div className="justify-center text-white/40 text-xs font-medium font-['Inter']">
                            Entegrasyonlarımız
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                // Dördüncü karta özel içerik
                <>
                  {/* Step Badge */}
                  <div className="size- px-3 py-1 rounded-md outline outline-1 outline-offset-[-1px] outline-white/10 inline-flex justify-start items-start">
                    <div className="justify-center text-white/60 text-xs font-medium font-['Inter']">
                      Step 4
                    </div>
                  </div>

                  {/* Title */}
                  <div className="self-stretch justify-center text-white text-xl font-bold font-['Inter'] mobile-integration-card-title">
                    Sürekli İzleme &amp; Optimizasyon
                  </div>

                  {/* Description */}
                  <div className="w-[460px] justify-center text-white/40 text-sm font-normal font-['Inter'] leading-6 mobile-integration-card-description">
                    Entegrasyonlarınız sürekli izlenir, performans
                    iyileştirmeleri yapılır ve yeni ihtiyaçlara göre
                    geliştirilir.
                  </div>

                  {/* Monitoring Dashboard Visual */}
                  <div className="self-stretch px-6 pt-10 pb-6 bg-stone-950 rounded-xl outline outline-1 outline-offset-[-1px] outline-white/5 inline-flex flex-col justify-start items-start mobile-integration-visual">
                    <div className="self-stretch flex flex-col justify-start items-start gap-1.5">
                      <div className="self-stretch px-4 py-3.5 bg-white/0 rounded-[10px] outline outline-1 outline-offset-[-1px] outline-white/5 inline-flex justify-between items-center">
                        <div className="size- flex justify-start items-center gap-3">
                          <div className="size-4 relative overflow-hidden">
                            <div className="w-3.5 h-3 left-[2.25px] top-[3px] absolute outline outline-1 outline-offset-[-0.56px] outline-white/30" />
                          </div>
                          <div className="size- inline-flex flex-col justify-start items-start gap-0.5">
                            <div className="self-stretch flex flex-col justify-start items-start">
                              <div className="justify-center text-white/75 text-xs font-semibold font-['Inter']">
                                Ödeme sistemi
                              </div>
                            </div>
                            <div className="self-stretch flex flex-col justify-start items-start">
                              <div className="justify-center text-white/30 text-xs font-normal font-['Inter']">
                                Aktif
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="size-4 inline-flex flex-col justify-start items-start">
                          <div className="size-4 relative overflow-hidden">
                            <div className="size-3.5 left-[1.50px] top-[1.50px] absolute outline outline-[1.50px] outline-offset-[-0.75px] outline-sky-300" />
                          </div>
                        </div>
                      </div>
                      <div className="self-stretch px-4 py-3.5 bg-white/0 rounded-[10px] outline outline-1 outline-offset-[-1px] outline-white/5 inline-flex justify-between items-center">
                        <div className="size- flex justify-start items-center gap-3">
                          <div className="size-4 relative overflow-hidden">
                            <div className="size-3.5 left-[2.25px] top-[2.25px] absolute outline outline-1 outline-offset-[-0.56px] outline-white/30" />
                            <div className="size-1 left-[6.75px] top-[6.75px] absolute outline outline-1 outline-offset-[-0.56px] outline-white/30" />
                          </div>
                          <div className="size- inline-flex flex-col justify-start items-start gap-0.5">
                            <div className="self-stretch flex flex-col justify-start items-start">
                              <div className="justify-center text-white/75 text-xs font-semibold font-['Inter']">
                                Kargo entegrasyonu
                              </div>
                            </div>
                            <div className="self-stretch flex flex-col justify-start items-start">
                              <div className="justify-center text-white/30 text-xs font-normal font-['Inter']">
                                Güncel
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="size-4 inline-flex flex-col justify-start items-start">
                          <div className="size-4 relative overflow-hidden">
                            <div className="w-2.5 h-3.5 left-[3.75px] top-[2.25px] absolute outline outline-[1.50px] outline-offset-[-0.75px] outline-sky-300" />
                          </div>
                        </div>
                      </div>
                      <div className="self-stretch px-4 py-3.5 bg-white/0 rounded-[10px] outline outline-1 outline-offset-[-1px] outline-white/5 inline-flex justify-between items-center">
                        <div className="size- flex justify-start items-center gap-3">
                          <div className="size-4 relative overflow-hidden">
                            <div className="size-3.5 left-[2.25px] top-[2.25px] absolute outline outline-1 outline-offset-[-0.56px] outline-white/30" />
                          </div>
                          <div className="size- inline-flex flex-col justify-start items-start gap-0.5">
                            <div className="self-stretch flex flex-col justify-start items-start">
                              <div className="justify-center text-white/75 text-xs font-semibold font-['Inter']">
                                ERP senkronizasyon
                              </div>
                            </div>
                            <div className="self-stretch flex flex-col justify-start items-start">
                              <div className="justify-center text-white/30 text-xs font-normal font-['Inter']">
                                Başarılı
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="size-4 inline-flex flex-col justify-start items-start">
                          <div className="size-4 relative overflow-hidden">
                            <div className="w-2.5 h-2 left-[3.75px] top-[5.25px] absolute outline outline-[1.50px] outline-offset-[-0.75px] outline-sky-300" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
